export const CASE_ACTIVITY_DRAWER = 'CaseActivityDrawer';
export const CONFLICTS_DISPLAY_WRAPPER = 'ConflictsDisplayWrapper';
export const SAVE_PENDING_LINK_WRAPPER = 'SavePendingLinkWrapper';
